export const makeEmptyExperienceFilter = () => {
  return {
    categoria: null,
    durata: null
  }
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/experience.js